import Logo from "../smallComponents/Logo";
import Input from "../smallComponents/Input";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGoogle } from "@fortawesome/free-brands-svg-icons";
import { Link, Navigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { formDataSent, validateEmail, validatePassword } from "./controllers";

// style
const divStyle = {
    width: "100%",
    // height: "100vh",
    height: "100svh",
    background: "linear-gradient(180deg, var(--headBackColor), #1c1b4a)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    gap: "20px",
    logoText: {
        // textAlign: "center",
    },
    loginContainer: {
        width: "30%",
        minWidth: "350px",
        height: "40%",
        minHeight: "400px",
        border: "1px solid #fff",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        borderRadius: "10px",
        gap: "10px",
        background: "rgba(255 255 255 / 5%)",

        logingHeading: {
            color: "#fff",
            marginBottom: "10px",
        },

        inputBox: {
            width: "80%",
        }
    },
    button: {
        padding: "10px 20px",
        fontSize: "20px",
        borderRadius: "7px",
        background: "var(--buttonColor)",
        color: "white",
        marginTop: "25px"
    }
}

const Login = () => {
    const [formData, setFormData] = useState({});
    const [response, setResponse] = useState({});
    const [target, setTarget] = useState();
    const [errorMessage, setErrorMessage] = useState("");
    const emailRef = useRef();
    const passwordRef = useRef();

    const [formSubmit, setFormSubmit] = useState(false);
    const [errorMeassages] = useState(
        {
            email: "Enter Validate Email",
            passwoard: "Enter Correct Password",
            invaladeInput: "Please fill inputs"
        }
    )

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // on input click
    const handleClick = (e) => {
        setFormSubmit(false);
        if (e.target.value.trim().length === 0) {
            e.target.style.outline = "2px solid red";
        }
        targetInputFilter(e);
    }
    async function dataPost() {
        const res = await formDataSent({
            url: `${process.env.REACT_APP_SERVER_URL}/login`, data: formData
        });
        return res;
    }

    // target filter by name
    function targetInputFilter(e) {
        switch (e.target.name) {
            case emailRef.current.name:
                setTarget(emailRef.current)
                break;
            case passwordRef.current.name:
                setTarget(passwordRef.current)
                break;;
            default:
                break;
        }
    }
    // target switch
    function swichCases(target) {
        switch (target?.name) {
            case "userEmail":
                styleChange(target, validateEmail(formData.userEmail));
                break;
            case "userPassword":
                styleChange(target, validatePassword(formData.userPassword));
                break;
            default:
                break;
        }
    }

    // target styling
    function styleChange(target, validation) {
        if (validation) {
            target.style.outline = "2px solid green";
        } else {
            target.style.outline = "2px solid red";
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormSubmit(true)
    };


    useEffect(() => {
        let meassage = null
        swichCases(target);
        // on from submit ---
        if (formSubmit) {
            if (formData.userEmail?.length > 1
                || formData.userPassword?.length > 1
            ) {
                if (!validateEmail(formData.userEmail)) {
                    meassage = errorMeassages.email;
                    setFormSubmit(false);
                } else if (!validatePassword(formData.userPassword)) {
                    meassage = errorMeassages.passwoard;
                    setFormSubmit(false);
                } else {
                    meassage = true;
                }
            } else {
                meassage = errorMeassages.invaladeInput;
                setFormSubmit(false);
            }
            setErrorMessage(meassage);

            // on submit style and data sent----
            if (errorMessage === true &&
                errorMessage !== errorMeassages.invaladeInput
            ) {
                if (dataPost()) {
                    dataPost().then(data => setResponse(data)) //response store data
                }
            } else {
                styleChange(emailRef.current, validateEmail(formData.userEmail));
                styleChange(passwordRef.current, validatePassword(formData.userPassword));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [target, formData, formSubmit, errorMessage])

    return (
        <>
            {response.login ?
                <Navigate to={"/"} /> :
                <form onSubmit={handleSubmit}>
                    <div style={divStyle}>
                        <Logo />
                        <div style={divStyle.loginContainer}>
                            <h2 style={divStyle.loginContainer.logingHeading}>Login</h2>
                            <div>
                                <FontAwesomeIcon icon={faGoogle} />
                            </div>
                            <div style={divStyle.loginContainer.inputBox}>
                                <Input
                                    type={"email"}
                                    labelText={"Email"}
                                    placeholder={"Enter your email"}
                                    name={"userEmail"}
                                    id={"userEmail"}
                                    func={{ "change": handleChange, "click": handleClick }}
                                    cRef={emailRef}
                                />
                            </div>
                            <div style={divStyle.loginContainer.inputBox}>
                                <Input
                                    type={"password"}
                                    labelText={"Password"}
                                    placeholder={"Enter your password"}
                                    name={"userPassword"}
                                    id={"userPassword"}
                                    func={{ "change": handleChange, "click": handleClick }}
                                    cRef={passwordRef}
                                />
                            </div>
                            {errorMessage && <p style={{ color: "white" }}>{errorMessage}</p>}
                            <button type="submit" style={divStyle.button} >Login</button>
                            <p style={{ color: "white" }}>
                                If you don't have an account <Link to={"/sign-up"} className="authenticationLink_color">Sign up</Link>
                            </p>
                        </div>
                    </div>
                </form>
            }
        </>
    );
}

export default Login;